/* eslint-disable */
import React from "react";

export const WhatsAppTemplates = () => {
  return (
    <div>WhatsAppTemplates</div>
  )
}